$(document).ready(function() {

    $("#requestInvoice").click(function() {
        var invoiceInfoIdSelected = $("[name=invoiceInfoId]").is(':checked');


        if (invoiceInfoIdSelected) {

            var params = {
                orderId: $("[name=orderId]").val(),
                invoiceInfoId: $("[name=invoiceInfoId]:checked").val(),
                isMultiprovider: $("[name=isMultiprovider]").val(),
            }
            requestBilling(params, false);

        }else {
            alert(FmtMessage.getMessage('js.invoice.not.selected.warning'));
        }

    });


})

var winstatus = 'scrollbars=yes,menubar=no,height=1024,width=800,resizable=yes,toolbar=no,location=no,status=no';

function getPaymentReceipt(orderId) {
	var url = URL_MAPPING.resolveUrl('/paymentReceipt');
	url = url +'?serviceType=1&orderId=' + orderId;
	var receiptwin = window.open(url, 'receiptWindow' + orderId, winstatus);
	receiptwin.focus();
}

function sendPaymentReceipt(orderId) {
	var isEmailValid = emailValidation('paymentReceiptEmail');
	if (!isEmailValid){
		return;
	}
	
	var email = $('#paymentReceiptEmail').val();
	
	$.ajax({
        type : "POST",
        async : true,
        url : "/paymentReceipt/send",
        data : {
			serviceType : 1,
			orderId : orderId,
			email : email
		},
        dataType : 'json',
        success : function(result) {
			if (result.status){
				alert(FmtMessage.getMessage('js.payment.receipt.sent'));
			}
        },
        error : function(xhr, ajaxOptions, errorThrown) {
            alert(FmtMessage.getMessage('js.general.error'));
        }
    });
}

function requestBilling(params, closePopup) {

    $.ajax({
        type : "POST",
        async : true,
        url : "/invoiceRequest",
        data : params,
        dataType : 'json',
        success : function(result) {

            if (closePopup){
                $("#newInvoiceDialog").dialog("open");
            }
            //alert(FmtMessage.getMessage('js.invoice.request.successfully.sent'));

            location.reload();
        },
        error : function(xhr, ajaxOptions, errorThrown) {
            alert(FmtMessage.getMessage('js.general.error'));
        }

    });
}

function addInvoice() {

}